import type { StateCreator } from 'zustand';

import type { User } from '@/models/users';

import type { StoreType } from '.';

export type UserSlice = {
   currentUser?: User;
   setCurrentUser: (user?: User) => void;
   isImpersonate: boolean;
   setIsImpersonate: (isImpersonate: boolean) => void;
};

export const userSlice: StateCreator<StoreType, [], [], UserSlice> = (set) => ({
   setCurrentUser: (currentUser) => set({ currentUser }),
   isImpersonate: false,
   setIsImpersonate: (isImpersonate) => set({ isImpersonate }),
});
